import { ErrorDialog, ErrorDialogProps } from "@codat/orchard-ui";
import React, { Component } from "react";

export interface ErrorDetails {
  statusCode?: number;
  correlationId: string;
  error: string;
}

interface ErrorBoundaryProps {
  FallbackComponent?: React.ComponentType<ErrorDialogProps>;
}

class ErrorBoundary extends Component<
  React.PropsWithChildren<ErrorBoundaryProps>,
  {
    hasError: boolean;
    error: ErrorDetails | null;
  }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  static getDerivedStateFromError(error: ErrorDetails) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError && this.state.error) {
      const { FallbackComponent } = this.props;
      const { statusCode = 500 } = this.state.error;
      return FallbackComponent ? (
        <FallbackComponent statusCode={statusCode} />
      ) : (
        <ErrorDialog
          statusCode={this.state.error.statusCode}
          message={this.state.error.error}
          correlationId={this.state.error.correlationId}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
